import { render, staticRenderFns } from "./MonitoramentoComponent.vue?vue&type=template&id=f86874d2&"
import script from "./MonitoramentoComponent.vue?vue&type=script&lang=js&"
export * from "./MonitoramentoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports